import {useEffect} from "react";
import {Route, Routes, useParams} from "react-router";
import type {GroupId} from "../../models/GroupRepo";
import {getGroupRepoLoader} from "../../models/GroupRepo";
import type {UserRepo} from "../../models/UserRepo";
import {StorageKey, storageWrapper} from "../../storage";
import NotFound from "../NotFound";
import CategoryOverview from "./CategoryOverview";
import GroupMenu from "./GroupMenu";
import GroupRecipes from "./GroupRecipes";
import GroupSettings from "./GroupSettings";
import ItemOverview from "./ItemOverview";

const RoutesForGroupId = ({groupId, userRepo}: {groupId: GroupId; userRepo: UserRepo}) => {
  const groupRepo = getGroupRepoLoader(groupId).useRepo(userRepo);
  useEffect(() => {
    if (groupId) {
      storageWrapper.storageSet(StorageKey.LAST_GROUP_ID, groupId);
    }
  }, [groupId]);
  return (
    <Routes>
      <Route path="categories/*" element={<CategoryOverview groupRepo={groupRepo} />} />
      <Route
        path="settings"
        element={<GroupSettings groupRepo={groupRepo} userRepo={userRepo} />}
      />
      <Route path="menu" element={<GroupMenu groupRepo={groupRepo} userRepo={userRepo} />} />
      <Route path="cook/*" element={<GroupRecipes userRepo={userRepo} groupRepo={groupRepo} />} />
      <Route path="*" element={<ItemOverview groupRepo={groupRepo} userRepo={userRepo} />} />
    </Routes>
  );
};

const GroupRoutes = ({userRepo}: {userRepo: UserRepo}) => {
  const {shortId} = useParams<{shortId: string}>();
  const myGroups = userRepo.Group.useGetAll();
  const group = Object.values(myGroups).find((g) => g.shortId === shortId);
  if (!group) {
    return <NotFound />;
  } else {
    return <RoutesForGroupId key={group.id} groupId={group.id} userRepo={userRepo} />;
  }
};
export default GroupRoutes;
